import { render } from "./step_image.vue?vue&type=template&id=d66100f4&scoped=true"
import script from "./step_image.vue?vue&type=script&lang=js"
export * from "./step_image.vue?vue&type=script&lang=js"

import "./step_image.vue?vue&type=style&index=0&id=d66100f4&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66100f4"]])

export default __exports__